__turbopack_context__.v({
  "listingsPagination": "pagination-module-scss-module__-g4QCW__listingsPagination",
  "listingsPagination_hidden": "pagination-module-scss-module__-g4QCW__listingsPagination_hidden",
  "listingsPagination_item": "pagination-module-scss-module__-g4QCW__listingsPagination_item",
  "listingsPagination_itemEllipsis": "pagination-module-scss-module__-g4QCW__listingsPagination_itemEllipsis",
  "listingsPagination_item__isActive": "pagination-module-scss-module__-g4QCW__listingsPagination_item__isActive",
  "listingsPagination_item__isDisabled": "pagination-module-scss-module__-g4QCW__listingsPagination_item__isDisabled",
  "listingsPagination_list": "pagination-module-scss-module__-g4QCW__listingsPagination_list",
});
